import React, { Component, Fragment } from 'react';
import Select from 'react-select';
import {get} from "../../../../server/actionsParent.js"
import {personModal,personType}from './../../../Parent/SchoolLunchBreakfastProgram/schoolLunchBreakfastModal'
import {BASE_URL} from "./../../../../server/constants"

class StudentsSearch extends Component {
    constructor(props){
        super(props);
    }
   
  render() {
        const {districtStatus,  allStudentList, otherStudents, selectedStudent, otherSelectedStudents, 
            onChangeStudent, onChangeOtherStudents, onSubmitStudentSelection, sourceFrom}=this.props;
            console.log("otherStudents::::",otherStudents);
            console.log("selectedStudent:::::",selectedStudent);
        return (<Fragment>
            <div className='panel panel-primary'>
                    <div className='panel-body'>
                        <div className='row'>
                            {
                                sourceFrom=='M'?
                                <div className='col-md-offset-2 col-md-8 form-group'>
                                    <label>Selected Student</label>
                                    <table className='table table-responsive'>
                                        <tbody>
                                     <tr>
                                            <td width='60%'><div className="checkbox" style={{marginTop:'0px', marginBottom:'0px'}}>
                                                        <label>
                                                            <input type="checkbox" checked key={-1}  /> {`${selectedStudent.firstName} ${selectedStudent.lastName}`}
                                                        </label>
                                                    </div></td>
                                            <td width='10%'>{selectedStudent.gradeName}</td><td width='30%'>{selectedStudent.studentId}</td>
                                        </tr>
                                       
                                   </tbody> </table>

                                </div>
                            :
                            sourceFrom=='A'?
                            <div className='col-md-offset-2 col-md-8 form-group'>
                                <label>Search for Student :</label>
                                <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    defaultValue={[{ value: (selectedStudent||{}).displayRecId||'', label: `${(selectedStudent||{}).firstName||''} ${(selectedStudent||{}).lastName||''}`, rec:{...(selectedStudent||{})} }]}
                                    isClearable={true}
                                    isSearchable={true}
                                    name="color"
                                    onChange={(selectedItem)=>{
                                        console.log("selectedItem::::",selectedItem);
                                        onChangeStudent((selectedItem||{}).rec);
                                        
                                    }}
                                    options={allStudentList.map((student)=>{
                                        return { value: student.displayRecId, label: `${student.firstName} ${student.lastName}`, rec:{...student} }
                                    })}
                                    menuPortalTarget={document.body} 
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>:null
                        }
                        </div>
                        {
                            otherStudents.length>0 &&
                            <div className='row'>
                                <div className='col-md-offset-2 col-md-8 form-group'>
                                    <label>Select Other kids also to apply</label>
                                    <table className='table table-responsive'>
                                        <tbody>
                                    {
                                        otherStudents.map((std,i)=>{
                                           // let index = otherSelectedStudents.findIndex(record => record.displayRecId === std.displayRecId);
                                            return <tr>
                                            <td width='60%'><div className="checkbox" style={{marginTop:'0px', marginBottom:'0px'}}>
                                                        <label>
                                                            <input type="checkbox" checked={otherSelectedStudents.some(selectedItem => selectedItem.displayRecId === std.displayRecId)} key={i} onChange={(e)=>{
                                                                onChangeOtherStudents(e,std)
                                                            }} /> {`${std.firstName} ${std.lastName}`}
                                                        </label>
                                                    </div></td>
                                            <td width='10%'>{std.gradeName}</td><td width='30%'>{std.studentId}</td>
                                        </tr>
                                        })
                                    }
                                   </tbody> </table>
                                </div>
                            </div>
                        }
                        {
                            (sourceFrom||'')!=='' && 
                            <div className='row form-group'>
                                <div className='col-md-12 text-right'>
                                    <button type='button' className='btn btn-sm btn-success' onClick={()=>{
                                        onSubmitStudentSelection()
                                    }}>Continue</button>
                                </div>
                            </div> 
                        }                                              
                    </div>
                </div>
                
            </Fragment>
        );
    }
}

export default StudentsSearch;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SchoolMealProgram/newLunchApplication/studentsSearch.js